import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { NoteSuggestionsQueryKeys } from "modules/NoteSuggestions/queryKeys";
import { ApiInstance } from "utils/Api";

import type { NoteSuggestion, NoteSuggestionType } from "models";

export type NoteSuggestionTypeWithSuggestions = {
  icon: string;
  default_message: string;
  translation_key: string;
  note_suggestions: NoteSuggestion[];
  note_suggestion_type: NoteSuggestionType;
};

export const useNoteSuggestionMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: NoteSuggestionTypeWithSuggestions) => {
      await ApiInstance.post("/note_suggestion/update", payload, ENV.appointmentBaseURL);
    },
    onSuccess: payload => {
      const dealerLocationData = typedQueryClient.getQueryData(NoteSuggestionsQueryKeys.location);
      const previousNotesTypeMatchIndex = dealerLocationData?.note_suggestion_types?.findIndex(
        type => type.note_suggestion_type_id === payload.note_suggestion_type.note_suggestion_type_id
      );

      if ((!previousNotesTypeMatchIndex && previousNotesTypeMatchIndex !== 0) || !dealerLocationData) return;

      const existingSuggestions = dealerLocationData.note_suggestions || [];
      const filteredSuggestions = existingSuggestions.filter(suggestion => suggestion.note_suggestion_type_id !== payload.note_suggestion_type.note_suggestion_type_id);
      const updatedNoteSuggestions = [...filteredSuggestions, ...payload.note_suggestions];

      const updatedNoteTypes = dealerLocationData.note_suggestion_types?.with(previousNotesTypeMatchIndex, payload.note_suggestion_type);

      typedQueryClient.setQueryData(NoteSuggestionsQueryKeys.location, {
        ...dealerLocationData,
        note_suggestion_types: updatedNoteTypes,
        note_suggestions: updatedNoteSuggestions
      });
    }
  });
